// extracted by mini-css-extract-plugin
module.exports = {"NextLevel":"NextLevel_NextLevel__UW8mv","NextLevel--active":"NextLevel_NextLevel--active__fe_3K"};